// extracted by css-extract-rspack-plugin
export default {"icon":"MissingOnHrMasterIcon__icon--KVaX_"};